module.exports = __webpack_public_path__ + "static/media/excel-no-border.dddd450e.svg";